import { Box, Info } from "lucide-react";
import { FC } from "react";
import { capitalize } from "~/utils";
import { useDeconsolidateStore } from "./deconsolidate.store";

type Props = {};

export const ReviewConfirm: FC<Props> = () => {
  const { selectedContainer, selectedPieces } = useDeconsolidateStore();

  return (
    <div className="bg-white rounded-lg border shadow-sm">
      <div className="p-4 border-b">
        <h2 className="font-medium">Review & Confirm</h2>
        <p className="text-sm text-gray-500 mt-1">
          Review and confirm the pieces to remove from the container
        </p>
      </div>

      <div className="p-6">
        <div className="mb-6">
          <h3 className="font-medium mb-3">Container</h3>
          <div className="border rounded-lg p-4 bg-gray-50">
            <div className="flex justify-between">
              <div>
                <div className="flex items-center space-x-2">
                  <Box size={20} className="text-blue-600" />
                  <span className="font-medium">
                    {selectedContainer?.title}
                  </span>
                </div>
                <div className="text-sm text-gray-500 mt-1">
                  {selectedContainer?.inventoryRef}
                </div>
              </div>
              <div className="text-right">
                <div className="text-sm">
                  {capitalize(selectedContainer?.containerType ?? "")}
                </div>
                <div className="text-sm text-gray-500">
                  {selectedContainer?.length}" × {selectedContainer?.width}" ×{" "}
                  {selectedContainer?.height}"
                </div>
                <div className="text-sm text-gray-500">
                  {selectedContainer?.location?.name}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-6">
          <h3 className="font-medium mb-3">
            Pieces to Deconsolidate ({selectedPieces.length})
          </h3>
          <div className="border rounded-lg overflow-hidden">
            <table className="w-full text-sm">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-4 py-2 text-left">ID</th>
                  <th className="px-4 py-2 text-left">Title</th>
                  <th className="px-4 py-2 text-left">Artist</th>
                  <th className="px-4 py-2 text-left">Dimensions</th>
                  <th className="px-4 py-2 text-left">Special Handling</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {selectedPieces.map((piece) => {
                  return (
                    <tr key={piece.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3">{piece.inventoryRef}</td>
                      <td className="px-4 py-3">{piece.title}</td>
                      <td className="px-4 py-3">{piece.artistName}</td>
                      <td className="px-4 py-3">
                        {piece.length}" × {piece.width}" × {piece.height}"
                      </td>
                      <td className="px-4 py-3">
                        <div className="flex flex-wrap gap-1">
                          {piece.specialHandling &&
                            piece.specialHandling.map((handling, idx) => (
                              <span
                                key={idx}
                                className="px-2 py-0.5 bg-blue-100 text-blue-800 rounded-full text-xs"
                              >
                                {capitalize(handling)}
                              </span>
                            ))}
                          {(!piece.specialHandling ||
                            piece.specialHandling.length === 0) &&
                            "-"}
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        <div className="p-4 bg-blue-50 border border-blue-100 rounded-lg">
          <div className="flex items-start">
            <Info
              size={20}
              className="text-blue-600 mr-3 flex-shrink-0 mt-0.5"
            />
            <div>
              <div className="font-medium">Important Information</div>
              <p className="text-sm mt-1">
                Deconsolidating these pieces will remove them from the container
                and make them individual items in the inventory. They will
                remain in the same location.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
